var _path, _path2, _path3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSignet(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63.9992 0H43.1992V64H63.9992V0Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2008 0H20.8008V64H43.2008V0Z",
    fill: "url(#paint1_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8 0H0V64H20.8V0Z",
    fill: "url(#paint2_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 53.5717,
    y1: 2.88959,
    x2: 53.5717,
    y2: 61.7668,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0000C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0324,
    stopColor: "#0112CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1328,
    stopColor: "#0545D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.238,
    stopColor: "#0871D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3462,
    stopColor: "#0A97DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4579,
    stopColor: "#0CB6E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5744,
    stopColor: "#0ECEE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6976,
    stopColor: "#0FDFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8323,
    stopColor: "#10E9EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#10ECEC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 31.9762,
    y1: 2.88959,
    x2: 31.9762,
    y2: 61.7668,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0000C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#10ECEC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 10.3778,
    y1: 2.88959,
    x2: 10.3778,
    y2: 61.7668,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0000C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1677,
    stopColor: "#0003C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3024,
    stopColor: "#010DCA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4256,
    stopColor: "#021ECD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5421,
    stopColor: "#0436D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6538,
    stopColor: "#0655D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.762,
    stopColor: "#087BDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8672,
    stopColor: "#0BA7E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9676,
    stopColor: "#0FDAE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#10ECEC"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignet);
export default __webpack_public_path__ + "static/media/signet.e66d316d820443f0026ef36ab7decd5b.svg";
export { ForwardRef as ReactComponent };